/* eslint-disable complexity */
import isObjectEmpty from "../helpers/isObjectEmpty";

export default (data) => {
    const details = {...data || {}};
    const mmv = details.vehicleMmv || {};
    if (isObjectEmpty(mmv)) return data;
    const {
        makeId,
        makeDisplay,
        modelId,
        modelDisplay,
        variantId,
        variantDisplayName,
        fuelType,
        transmissionType,
        year,
        yearId
    } = mmv || {};

    const isMakePresent = makeDisplay && makeId;
    const isModelPresent = modelDisplay && modelId;

    if (isMakePresent) {
        details.brand = {
            "make_id": makeId,
            "make_display": makeDisplay
        };
    }

    if (isModelPresent) {
        details.model = {
            "model_id": modelId,
            "model_display": modelDisplay
        };
    }

    if (year && yearId) {
        details.year = {
            "year_id": yearId,
            year
        };
    }

    if (isMakePresent && isModelPresent && variantDisplayName && variantId && fuelType && transmissionType) {
        details.ds_details = [{
            "make_id": makeId,
            "model_id": modelId,
            "variant": {
                "fuel_type": fuelType,
                "transmission_type": transmissionType,
                "variant_display_name": variantDisplayName,
                "variant_name": variantDisplayName,
                "variant_id": variantId
            }
        }];
    }
    return details;

};
